
// URL base del backend (ConsumosApiTALSA)
const linkBackend = 'https://consumos.talsa.com.co/api/talsa/proyectos';

// Token de acceso — debe coincidir con apiKeyProyectos en el backend
const apiKeyProyectos = 'tlsa-proj-2026-xK9mQpR4vW8nZ2jY';

export { linkBackend, apiKeyProyectos };
